export default __webpack_public_path__ + "static/media/DSAutomobilesRegular.7a42b0c2.otf";